import { NewsletterForm } from '@components/form/templates/NewsletterForm';
import { ReviewForm } from '@components/form/templates/ReviewForm';
import { FormContext, FormShape } from '@enums';
import { Enum_Componentformtemplatesregistration_Identifier } from '@graphql/generated/graphql';
import { CustomerInputType } from '@hello-pimster/pimster-crm-sdk';
import { UseFormSubmitMutate } from '@hooks';
import { SinglePageTemplateForm as SinglePageTemplateFormType } from '@types';

import { RegistrationForm } from '../templates/RegistrationForm';

interface Props {
    form: SinglePageTemplateFormType;
    customerInputType?: CustomerInputType;
    context?: FormContext;
    shape: FormShape;
    isSubmitting: boolean;
    onSubmit: UseFormSubmitMutate;
}

export const SinglePageTemplateForm = ({
    form,
    customerInputType,
    context,
    shape,
    isSubmitting,
    onSubmit,
}: Props) => {
    const formTemplate = form.Elements[0];

    switch (formTemplate.__typename) {
        case 'ComponentFormTemplatesNewsletter':
            return (
                <NewsletterForm
                    formName={form.Name}
                    formUID={form.UID || ''}
                    formType={form.Type}
                    formContext={context}
                    formShape={shape}
                    companyName={form.Company?.Name || ''}
                    title={formTemplate.Title}
                    description={formTemplate.Description}
                    isNameRequired={formTemplate.IsNameRequired}
                    emailConsent={formTemplate.EmailConsent}
                    ctaText={form.CtaText}
                    isSubmitting={isSubmitting}
                    onSubmit={onSubmit}
                />
            );

        case 'ComponentFormTemplatesRegistration':
            return (
                <RegistrationForm
                    formName={form.Name}
                    formUID={form.UID || ''}
                    formType={form.Type}
                    formContext={context}
                    formShape={shape}
                    identifier={
                        form.Elements[0].__typename ===
                        'ComponentFormTemplatesRegistration'
                            ? form.Elements[0].Identifier
                            : Enum_Componentformtemplatesregistration_Identifier.Email
                    }
                    companyName={form.Company?.Name || ''}
                    customerInputType={customerInputType!}
                    isSubmitting={isSubmitting}
                    emailConsent={formTemplate.EmailConsent}
                    onSubmit={onSubmit}
                />
            );

        case 'ComponentFormTemplatesReview':
            return (
                <ReviewForm
                    formName={form.Name}
                    formUID={form.UID || ''}
                    formType={form.Type}
                    formContext={context}
                    formShape={shape}
                    isSubmitting={isSubmitting}
                    onSubmit={onSubmit}
                />
            );

        default:
            return null;
    }
};
